import { Button } from 'components/atoms';
import { useNavbarIcon } from 'hooks';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { PiCaretLeftBold } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { ITopBarProps } from 'types/components/topbar/topbar.interface';
import './TopBar.scss';

const TopBar = ({
  children,
  title = '',
  path,
  customBackItem,
  topbarContent,
  isChildrenVisible = true,
  size = 'default',
  useHelmet = true,
  hideHeader = false,
  hideBackButton = false,
}: ITopBarProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const NavbarIcon = useNavbarIcon();

  return (
    <div className={`topbar-wrapper ${size}`}>
      <div className='topbar'>
        {useHelmet && (
          <Helmet>
            <title>MagelUP {title}</title>
          </Helmet>
        )}
        {!hideHeader && (
          <div className='header'>
            {!hideBackButton &&
              (customBackItem ?? (
                <Button
                  onlyIcon
                  onClick={() =>
                    path
                      ? navigate(`/${path}`, { replace: true })
                      : navigate(-1)
                  }>
                  <Button.Description description={t('button.back')} />
                  <Button.Icon icon={<PiCaretLeftBold />} />
                </Button>
              ))}
            {title && (
              <div
                className='title'
                style={hideBackButton ? { marginLeft: '11px' } : undefined}>
                {hideBackButton && NavbarIcon && (
                  <NavbarIcon
                    style={{ marginRight: '12px', fontSize: '24px' }}
                  />
                )}
                {title}
              </div>
            )}
          </div>
        )}
        <div className='children'>{topbarContent}</div>
      </div>
      {isChildrenVisible && children}
    </div>
  );
};

export default TopBar;
